import React, {memo, useCallback} from 'react';

import {useTranslation} from 'react-i18next';
import {useLocation} from 'react-router-dom';

import {AppButton, AppButtonVariant} from '@/app/shared-components';

import {getEditInfoImage, redirectToEditInfoApp} from './constants';
import EditInfoLayout from './EditInfoLayout';
import {useEditInfoTrackers} from './useEditInfoTrackers';

function EditInfoErrorContent() {
  const {t} = useTranslation();
  const location = useLocation();

  const isMoGold: boolean = location.state?.isMoGold ?? false;

  const {trackSelectEditInfoBackToApp} = useEditInfoTrackers({
    parentId: location.state?.parentId ?? '',
  });

  const handleGoBackToApp = useCallback(() => {
    trackSelectEditInfoBackToApp();
    redirectToEditInfoApp();
  }, [trackSelectEditInfoBackToApp]);

  return (
    <EditInfoLayout
      illustrationSrc={getEditInfoImage('moSad', isMoGold)}
      title={t('edit_info.error.title')}
      description={t('edit_info.error.description')}
      buttons={
        <AppButton
          id="EditInfoError_goBackToAppButton"
          sentry-label="EditInfoError go back to app button"
          label={t('edit_info.error.primary_button')}
          onClick={handleGoBackToApp}
          variant={
            isMoGold
              ? AppButtonVariant.onPrimary
              : AppButtonVariant.onPrimaryGreen
          }
        />
      }
    />
  );
}

const EditInfoErrorPage = memo(() => <EditInfoErrorContent />);

export default EditInfoErrorPage;
